import { render, staticRenderFns } from "./ListCase.vue?vue&type=template&id=3c9b637f&scoped=true&"
import script from "./ListCase.vue?vue&type=script&lang=js&"
export * from "./ListCase.vue?vue&type=script&lang=js&"
import style0 from "./ListCase.vue?vue&type=style&index=0&id=3c9b637f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9b637f",
  null
  
)

export default component.exports